<template>
	<div id="pagination">
		<nav aria-label="Page navigation example">
			<ul class="pagination pagination-sm justify-content-center" v-if="pagination.lastPage > 1">
				<li class="page-item" :class="(pagination.currentPage > 1) ? '' : 'disabled'">
					<span class="page-link pointer" @click="clickButtonPage(1)"><<</span>
				</li>
				<li class="page-item" :class="(pagination.currentPage > 1) ? '' : 'disabled'">
					<span class="page-link pointer" href="" @click="clickButtonPage(pagination.currentPage - 1)"><</span>
				</li>
				<li class="page-item" v-for="item in pagination.getUrlRange" :class="(pagination.currentPage == getPageUrl(item)) ? 'active' : ''">
					<span class="page-link pointer" @click="clickButtonPage(getPageUrl(item))" v-if="pagination.currentPage != getPageUrl(item)">
						{{ getPageUrl(item) }}
					</span>
					<span class="page-link pointer" v-else>
						{{ getPageUrl(item)  }}
						<span class="sr-only">(current)</span>
					</span>					
				</li>
				<li class="page-item" :class="(pagination.currentPage < pagination.lastPage) ? '' : 'disabled'">
					<span class="page-link pointer" @click="clickButtonPage(pagination.currentPage + 1)">></span>
				</li>
				<li class="page-item" :class="(pagination.currentPage < pagination.lastPage) ? '' : 'disabled'">
					<span class="page-link pointer" @click="clickButtonPage(pagination.lastPage)">>></span>
				</li>
				<li class="page-item disabled">
					<span class="page-link pointer">{{ pagination.total }} resultados</span>
				</li>
			</ul>
			<div class="pagination pagination-sm justify-content-center" v-else>
				<li class="page-item disabled">
					<span class="page-link pointer">{{ pagination.total }} resultados</span>
				</li>
			</div>
		</nav>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
  name: 'pagination',
  props: ['pagination'],
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
	  clickButtonPage(page) {
		  this.$emit('getAllList', page)
	  },
	  getPageUrl(url) {
		  return url.split('=')[1];
	  }
  }
}</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
